export abstract class Model {
  public equals(obj: unknown): boolean {
    return this === obj;
  }
}